import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { useToast } from "../other/Toast";
import { Tag } from "primereact/tag";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import Reaptcha from "reaptcha";
import recaptcha from "../../recaptcha";
import SecurityService from "../service/SecurityService";
import { useForm, Controller } from "react-hook-form";
import { classNames } from "primereact/utils";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import InputText from "../other/InputText";
import { setAuthorizedPerson } from "../../redux/directorSlice";

const CustomerRegForm = () => {
  const toast = useToast();
  const history = useHistory();
  const [type, setType] = useState("I");
  const [username, setUsername] = useState();
  const [recaptchaVerified, setRecaptchaVerified] = useState(true);
  const [phoneError, setPhoneError] = useState();
  const [captchaImage, setCaptchaImage] = useState();
  const [captchaImageId, setCaptchaImageId] = useState();
  const [captchaImageText, setCaptchaImageText] = useState();
  const [audio, setAudio] = useState();
  const [t] = useTranslation();
  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm({});
  const [suggestions, setSuggestions] = useState([]);
  const getFormErrorMessage = (name) => {
    return (
      errors[name] && <small className="p-error">{errors[name].message}</small>
    );
  };

  useEffect(() => {
    SecurityService.generateCaptcha().then((response) => {
      setCaptchaImage("data:image/png;base64," + response.data.image);
      setCaptchaImageId(response.data.id);
      setAudio(response.data.audio);
    });
  }, []);

  const generateCaptcha = () => {
    SecurityService.generateCaptcha().then((response) => {
      setCaptchaImage("data:image/png;base64," + response.data.image);
      setCaptchaImageId(response.data.id);
      setAudio(response.data.audio);
    });
  }

  const playAudio = () => {
    console.log("audio");
    new Audio('data:audio/wav;base64,' + audio).play();
  }


  const [rloading, setRloading] = useState(false);

  const getUsernameSuggestion = () => {
    const data = control._formValues;
    data.username = username;
    data.name =
      data.type === "I"
        ? data.fname +
        " " +
        (data.mname && data.mname.trim() ? data.mname.trim() + " " : "") +
        data.lname
        : data.name;

    SecurityService.getUsernameSuggestion(data)
      .then((response) => {
        setSuggestions(response.data);
      })
      .catch((error) => {
        if (!error || !error.response)
          toast.error("Unsuccessful", "Unable to connect to the server");
        else
          switch (error.response.status) {
            case 400:
              if (error.response.data.error_description)
                toast.error("Unsuccessful", error.response.data.error_description);
              break;
            case 409:
              if (error.response.data.error_description)
                toast.error("Unsuccessful", error.response.data.error_description);
            case 500:
              if (error.response.data.error_description)
                toast.error("Unsuccessful", error.response.data.error_description);
              else
                toast.error("Unsuccessful", "Internal Server Error");
              break;
            case 503:
              toast.error("Unsuccessful", "Service Temporarly not available");
              break;
            default:
              toast.error("Unsuccessful", "Unexpected Error");
          }
      });
  };

  const onSubmit = (data) => {
    console.log("e.target", data);
    data.username = username;
    data.name =
      data.type === "I"
        ? data.fname +
        " " +
        (data.mname && data.mname.trim() ? data.mname.trim() + " " : "") +
        data.lname
        : data.name;
    data.captchaId = captchaImageId;
    data.captchaText = captchaImageText;

    if (
      data.phone &&
      data.phone.startsWith("977") &&
      data.phone.length !== 13
    ) {
      setPhoneError("Phone number must be 10 digit for Nepal");
      return;
    } else setPhoneError("");

    setRloading(true);
    SecurityService.register(data)
      .then((response) => {
        setRloading(false);
        toast.success("Successful", "User Registered sucessfully. Check email for user credentials");
        setTimeout(() => history.push("/login"), 2000);
      })
      .catch((error) => {
        setRloading(false);
        if (!error || !error.response)
          toast.error("Unsuccessful", "Unable to connect to the server");
        else
          switch (error.response.status) {
            case 400:
              if (error.response.data.error_description)
                toast.error("Unsuccessful", error.response.data.error_description);
              break;
            case 409:
              if (error.response.data.error_description) {
                toast.error("Unsuccessful", error.response.data.error_description);
                if (
                  error.response.data.error_description ===
                  "Username already Exists"
                )
                  getUsernameSuggestion();
              }
              else if (error.response.data.message !== null)
                toast.error("Unsuccessful", error.response.data.message);
              break;
            case 500:
              if (error.response.data.error_description)
                toast.error("Unsuccessful", error.response.data.error_description);
              else
                toast.error("Unsuccessful", "Internal Server Error");
              break;
            case 503:
              toast.error("Unsuccessful", "Service Temporarly not available");
              break;
            default:
              toast.error("Unsuccessful", "Unexpected Error");
          }
      });
  };

  return (
    <div className="compact-layout landing-page-card">
      <div
        style={{
          maxWidth: 700,
          display: "flex",
          alignContent: "center",
          justifyContent: "center",
          placeContent: "center",
          backgroundColor: "#fff",
        }}
        className="p-col-12"
      >
        <div style={{ padding: 0 }} className="col-md-12">
          <div
            className="p-grid p-fluid"
            style={{ borderBottom: "1px solid #efefef" }}
          >
            <div
              style={{
                fontSize: 15,
                textAlign: "center",
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignContent: "center",
                alignItems: "center",
                padding: 20,
              }}
              className="p-col-12 p-md-12"
            >
              <img src="./cdsc-Blue-Logo.png" style={{ height: 50 }} />{" "}
              <span
                style={{
                  paddingLeft: 10,
                  fontSize: 36,
                  textAlign: "center",
                  color: "#008080",
                  fontFamily: "'Spectral', serif",
                  transform: "scale(1.25,1)",
                }}
              >
                CKYC
              </span>
            </div>
            {/* <label className="p-field p-col-12 p-md-12 padding-5" style={{ textAlign: 'center', width: '100%', fontSize: 20, fontWeight: 'bold' }}><i className="pi pi-user-plus"></i> Customer Registration</label> */}
          </div>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="p-grid p-fluid" style={{ padding: 20 }}>
              <p
                className="p-col-12 registration-form-field-padding"
                style={{ textAlign: "center", marginBottom: "0px!important" }}
              >
                Fill up the form to complete the Registration Process
              </p>
              <div className="p-field p-col-12 p-md-12 registration-form-field-padding">
                <label className="p-col-12">
                  <i className="pi pi-user"></i> Type
                </label>
                <Controller
                  name="type"
                  control={control}
                  rules={{ required: "Type is required." }}
                  render={({ field, fieldState }) => (
                    <Dropdown
                      id={field.name}
                      {...field}
                      className={classNames({
                        "p-invalid": fieldState.invalid,
                      })}
                      onChange={(e) => {
                        setType(e.target.value);
                        field.onChange(e.value);
                      }}
                      options={[
                        { label: "Individual", value: "I" },
                      ]}
                      placeholder={t("Select Customer Type")}
                    />
                  )}
                />
                {getFormErrorMessage("type")}
              </div>
              {type === "I" ? (
                <div className="p-field p-col-12 p-md-12 registration-form-field-padding">
                  <label className="p-col-12">
                    <i className="pi pi-user"></i> Name
                  </label>
                  <div style={{ display: "flex" }}>
                    <Controller
                      name="fname"
                      control={control}
                      rules={{
                        required: "First Name is required.",
                      }}
                      render={({ field, fieldState }) => (
                        <InputText
                          id={field.name}
                          {...field}
                          isName
                          keyfilter="alpha"
                          className={classNames({
                            "p-invalid": fieldState.invalid,
                          })}
                          placeholder="First Name"
                        />
                      )}
                    />
                    <Controller
                      name="mname"
                      control={control}
                      render={({ field, fieldState }) => (
                        <InputText
                          id={field.name}
                          {...field}
                          isName
                          keyfilter={/^[a-zA-Z ]*$/}
                          className={classNames({
                            "p-invalid": fieldState.invalid,
                          })}
                          placeholder="Middle Name"
                        />
                      )}
                    />
                    <Controller
                      name="lname"
                      control={control}
                      rules={{
                        required: "Last Name is required.",
                      }}
                      render={({ field, fieldState }) => (
                        <InputText
                          keyfilter="alpha"
                          isName
                          id={field.name}
                          {...field}
                          className={classNames({
                            "p-invalid": fieldState.invalid,
                          })}
                          placeholder="Last Name"
                        />
                      )}
                    />
                  </div>
                  {getFormErrorMessage("name")}
                </div>
              ) : (
                <div className="p-field p-col-12 p-md-12 registration-form-field-padding">
                  <label className="p-col-12">
                    <i className="pi pi-user"></i> Name
                  </label>
                  <Controller
                    name="name"
                    control={control}
                    rules={{
                      required: "Name is required.",
                    }}
                    render={({ field, fieldState }) => (
                      <InputText
                        id={field.name}
                        {...field}
                        keyfilter={/^[a-zA-Z0-9\-\.\,\/\(\) ]$/}
                        clearSpace
                        className={classNames({
                          "p-invalid": fieldState.invalid,
                        })}
                        placeholder="Name"
                      />
                    )}
                  />
                  {getFormErrorMessage("name")}
                </div>
              )}
              <div
                className="p-field p-col-12 p-md-4 stick-right"
                style={{ paddingTop: 0 }}
              >
                <label className="p-col-12">
                  <i className="pi pi-key"></i> Username
                </label>
                <Controller
                  name="username"
                  control={control}
                  rules={{ required: "Username is required." }}
                  render={({ field, fieldState }) => (
                    <InputText
                      id={field.name}
                      {...field}
                      keyfilter="alphanum"
                      value={username}
                      onChange={(e) => {
                        setUsername(e.target.value);
                        field.onChange(e.target.value);
                      }}
                      className={classNames({
                        "p-invalid": fieldState.invalid,
                      })}
                      placeholder="Username"
                    />
                  )}
                />
                {getFormErrorMessage("username")}
              </div>
              <div
                className="p-field p-col-12 p-md-4 stick-right stick-left"
                style={{ paddingTop: 0 }}
              >
                <label className="p-col-12">
                  <i className="pi pi-envelope"></i> Email
                </label>
                <Controller
                  name="email"
                  control={control}
                  rules={{
                    required: "Email is required.",
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                      message: "Provide valid email address",
                    },
                  }}
                  render={({ field, fieldState }) => (
                    <InputText
                      keyfilter="email"
                      id={field.name}
                      {...field}
                      className={classNames({
                        "p-invalid": fieldState.invalid,
                      })}
                      type="email"
                      placeholder="Email"
                    />
                  )}
                />
                {getFormErrorMessage("email")}
              </div>
              <div
                className="p-field p-col-12 p-md-4 stick-left"
                style={{ paddingTop: 0 }}
              >
                <label className="p-col-12">
                  <i className="pi pi-mobile"></i> Mobile No.
                </label>
                <Controller
                  name="phone"
                  control={control}
                  rules={{
                    required: "Mobile No. is required.",
                  }}
                  render={({ field, fieldState }) => (
                    <PhoneInput
                      id={field.name}
                      {...field}
                      className={classNames({
                        "p-invalid": fieldState.invalid,
                      })}
                      country={"np"}
                      placeholder="Mobile No."
                    />
                  )}
                />
                {getFormErrorMessage("phone")}
                {phoneError && <small className="p-error">{phoneError}</small>}
              </div>
              {suggestions && !!suggestions.length && (
                <div className="p-field p-col-12 p-md-12">
                  <div
                    className="p-col-12 p-md-12 registration-form-field-padding"
                    style={{ padding: 0, textAlign: "center" }}
                  >
                    Username suggestions (Click to choose) :
                  </div>
                  <div
                    className="p-col-12 p-md-12 registration-form-field-padding"
                    style={{
                      padding: "5px 0px",
                      display: "flex",
                      flexWrap: "wrap",
                      justifyContent: "center",
                    }}
                  >
                    {suggestions &&
                      suggestions.map((suggestion) => (
                        <>
                          <a
                            className="p-mr-2 username-suggestion-a"
                            href="#"
                            onClick={(e) => setUsername(suggestion)}
                          >
                            <Tag
                              severity="info"
                              style={{
                                margin: 5,
                                fontSize: 11.5,
                                borderRadius: "16px",
                                backgroundColor: "#70b7b7",
                                color: "#fff",
                                padding: "5px 10px",
                              }}
                            >
                              {" "}
                              {suggestion}{" "}
                            </Tag>
                          </a>
                        </>
                      ))}
                  </div>
                </div>
              )}
              {captchaImage && <div
                className="p-field p-col-12 p-md-12"
                style={{ padding: "0.5rem 0" }}
              >
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >

                  <div style={{ display: 'flex', flexDirection: 'column', placeContent: 'flex-end', cursor: 'pointer', padding: 5 }}>
                    <i className="pi pi-refresh" onClick={(e) => generateCaptcha()} />
                    {/* <Button icon="pi pi-refresh" className="p-col-12 p-md-3" type="button" onClick={(e) => generateCaptcha()}>Refresh</Button> */}

                  </div>
                  <img src={captchaImage} alt="Captcha Image" />

                  <div style={{ display: 'flex', flexDirection: 'column', placeContent: 'flex-end', cursor: 'pointer', padding: 5 }}>

                    <i className="pi pi-play" onClick={(e) => playAudio()} />
                    {/* <Button icon="pi-play" className="p-col-12 p-md-3" type="button" onClick={(e) => playAudio()}>Play</Button> */}
                  </div>
                </div>
              </div>}
              <div className=" p-md-12 " >
                <label className="p-col-12">
                  Please type the text shown in the image
                </label>
                <Controller
                  name="capchaText"
                  control={control}
                  rules={{
                    required: "Captcha text is required.",
                  }}
                  render={({ field, fieldState }) => (
                    <InputText
                      id={field.name}
                      {...field}
                      className={classNames({
                        "p-invalid": fieldState.invalid,
                      })}
                      type="text"
                      placeholder="Text here"
                      onChange={(e) => {
                        setCaptchaImageText(e.target.value);
                        field.onChange(e.target.value);
                      }}
                    />)} />
                {getFormErrorMessage("capchaText")}
              </div>
              <div className="p-field p-col-12 p-md-12 registration-form-field-padding">
                <Button
                  type="submit"
                  disabled={!recaptchaVerified}
                  label="Register"
                  loading={rloading}
                  iconPos="right"
                ></Button>
              </div>
              <div
                className=" p-col-12 p-md-12"
                style={{ textAlign: "center" }}
              >
                Already a user?{" "}
                <a style={{ textDecoration: "none" }} href="/login">
                  Login
                </a>
              </div>
            </div>
          </form>
        </div>
      </div >

    </div >
  );
};

export default CustomerRegForm;
